// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/be2cbb97752eba3b0253.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"32dc2c19da771f03e21c","129":"92fc1e9464086ba49168","130":"de6362f4c03ffb290341"}[chunkId] + ".chunk.js";
};